import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const BrandingContext = createContext({});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    portalName: 'Srauto Portalas',
    portalSub:  'Axis Object Analytics',
    logoData:   '',
  });

  useEffect(() => {
    api.get('/settings/branding').then(r => setBranding(r.data)).catch(() => {});
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
